import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import Dialog from './../../components/Dialog/Dialog';

import RequestListItem from './../../components/Request/RequestListItem'
import Header from './../../components/Header';
import SuperAdminHeader from './../../components/Header/SuperAdmin';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';



class RequestsPage extends PureComponent {

    constructor(props) {
        super(props);
        autobind(this);

        this.state = {
            currentView: 'messages',
            toDeleteMessagesId: [],
            confirmDeleteModalOpen: false
        }
    }

    componentDidMount() {
        this.getMessages();
        this.getReports();
    }

    readMessages(myUnreadMessages) {
        const myUnreadMessagesParanoidMode = myUnreadMessages.filter(m => m.to.id === this.props.user._id && !m.read)
        if(myUnreadMessagesParanoidMode.length)
            this.props.readMessages(myUnreadMessagesParanoidMode.map(m => m.id))
    }

    onSendButtonClick(toId, identifier, messageTypeId, message) {
        this.props.addMessage(this.props.user._id, toId, identifier, message, () => {
            this.getMessages();
        });
    }

    getMessages() {
        this.props.getMessages();
    }

    getReports() {
        this.props.getReports();
    }

    onRequestDelete(messages) {
        this.props.deleteMessages(messages.map(message => message.id), () => {
            this.getMessages()
            this.getReports();
        })
    }

    confirmDeleteModalProceed() {
        const { toDeleteMessagesId } = this.state

        if (toDeleteMessagesId.length) {
            this.props.deleteMessages(toDeleteMessagesId, () => {
                this.confirmDeleteModalHide()
                this.getMessages()
                this.getReports();
            })
        }

    }

    confirmDeleteModalShow(messages) {
        this.setState({
            toDeleteMessagesId: messages.map(message => message.id),
            confirmDeleteModalOpen: true
        })
    }

    confirmDeleteModalHide() {
        this.setState({
            confirmDeleteModalOpen: false
        })
    }

    changeView(e) {
        e.preventDefault();

        const { currentView } = this.state

        if (currentView === 'messages') {
            this.getReports();
        } else {
            this.getMessages();
        }

        this.setState({
            currentView: currentView === 'messages' ? 'reports' : 'messages'
        })

    }

    render() {

        const { messages, total, reports, reportsTotal } = this.props;
        let threads = [];

        if (messages.length) {

            threads = messages.map((message, index) => {
                console.log(message)
                return <RequestListItem
                    index={messages.length - index}
                    key={'request_' + index}
                    onSendButtonClick={this.onSendButtonClick}
                    onRequestDelete={this.confirmDeleteModalShow}
                    message={message}
                    messages={message.messages}
                    // messageTitle={message.messages.find(m => m.title).title}
                    // latestMessage={striptags(message.messages[0].message)}
                    readMessages={this.readMessages}
                    product={message.product}
                    notification={message.notification}
                    conversationPartner={message.conversationPartner}
                    userImagePath={message.conversationPartner.picturePath}
                    // latestMessageDate={message.messages[0].createdAt}
                    reply={true}
                    user={this.props.user}
                />;
            });
            threads.reverse();
        }

        let reportThreads = [];

        if (reports.length) {

            reportThreads = reports.map((report, index) => {
                return <RequestListItem
                    index={reports.length - index}
                    key={'request_' + index}
                    onSendButtonClick={this.onSendButtonClick}
                    onRequestDelete={this.confirmDeleteModalShow}
                    message={report}
                    messages={report.messages}
                    // messageTitle={report.messages.find(m => m.title).title}
                    // latestMessage={striptags(report.messages[0].message)}
                    readMessages={this.readMessages}
                    product={report.product}
                    notification={report.notification}
                    conversationPartner={report.conversationPartner}
                    userImagePath={report.conversationPartner.picturePath}
                    // latestMessageDate={report.messages[0].createdAt}
                    reply={false}
                    user={this.props.user}
                />;
            })
            reportThreads.reverse()

        }

        return (
            <div className={`${this.props.user.role === 3 ? "superadmin" : ""}`}>
                {this.props.user.role === 3 ? <SuperAdminHeader /> : <Header />}
                <Subheader search={false} breadcrumbs={["Messages"]} />
                <div className="container mt-5">
                    <ul role="tablist" className="nav nav-tabs nav-tabs-primary">
                        <li className="nav-item">
                            <a href="#home" data-toggle="tab" role="tab" className={'messages' === this.state.currentView ? 'nav-link active' : 'nav-link'} onClick={(e) => { this.changeView(e) }}>Messages</a>
                        </li>
                        <li className="nav-item">
                            <a href="#home" data-toggle="tab" role="tab" className={'reports' === this.state.currentView ? 'nav-link active' : 'nav-link'} onClick={(e) => { this.changeView(e) }}>Problem reports</a>
                        </li>
                    </ul>
                    {this.state.currentView === 'messages' ? (<div><div className="items-list-filters">
                        <h4 className="mb-0">Messages ({total})</h4>
                    </div>
                        <div className="items-list items-list--requests">
                            <div className="items-labels">
                                <div className="items-label-index">#</div>
                                <div className="items-label-1">Message type</div>
                                <div className="items-label-2">Product / Notification</div>
                                <div className="items-label-3">User</div>
                                <div className="items-label-4">Date</div>
                                <div className="items-label-5">Actions</div>
                            </div>
                            {threads.length ? threads : <p>You have no messages.</p>}
                        </div></div>) : (<div><div className="items-list-filters">
                            <h4 className="mb-0">Problem reports ({reportsTotal})</h4>
                        </div>
                            <div className="items-list items-list--requests">
                                <div className="items-labels">
                                    <div className="items-label-1">Message type</div>
                                    <div className="items-label-2">Product / Notification</div>
                                    <div className="items-label-3">User</div>
                                    <div className="items-label-4">Date</div>
                                    <div className="items-label-5">Actions</div>
                                </div>
                                {reportThreads.length ? reportThreads : <p>You have no reports.</p>}
                            </div></div>)}
                    {/* <div className="list-pagination d-flex justify-content-between">
                    <p>Showing 1 to 6 of 57 entries</p>
                    <nav>
                        <ul className="pagination pagination-rounded">
                            <li className="page-item"><a href="#" aria-label="Previous" className="page-link"><span aria-hidden="true" className="s7-angle-left"></span></a></li>
                            <li className="page-item"><a href="#" className="page-link">1</a></li>
                            <li className="page-item active"><a href="#" className="page-link">2</a></li>
                            <li className="page-item"><a href="#" className="page-link">3</a></li>
                            <li className="page-item"><a href="#" className="page-link">4</a></li>
                            <li className="page-item"><a href="#" aria-label="Next" className="page-link"><span aria-hidden="true" className="s7-angle-right"></span></a></li>
                        </ul>
                    </nav>
                </div> */}
                </div>
                <Dialog open={this.state.confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="This item won't be retreivable after deletion." />
                <Footer />
            </div>
        )
    }

}

export default connect(
    (state, ownProps) => {
        const { messages: { requesting, messages, total, error }, reports: { reports, reportsTotal }, auth: { user } } = state
        return { requesting, messages: messages, total, reports, reportsTotal, user, error }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(RequestsPage))



// WEBPACK FOOTER //
// ./src/containers/Request/Requests.js